module.exports = __webpack_public_path__ + "a5afb9764990d0b5a52001cbea90d75f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/greetings/tango.png
// module id = 2801
// module chunks = 0